export function renderNavigationBarrelImportsTemplate({
  namespacePascal,
  namespaceAlias,
  extractImports,
  namespaceRoutePath,
  spreadLinesContent,
  namespaceCamel
}: {
  namespacePascal: string
  namespaceAlias: string
  extractImports: string
  namespaceRoutePath: string
  spreadLinesContent: string
  namespaceCamel: string
}): string {
  return `import { House, ImagePlay } from 'lucide-react'
import type { ${namespacePascal}NavigationItem } from '${namespaceAlias}/types/navigation'${extractImports}

export type { ${namespacePascal}NavigationItem } from '${namespaceAlias}/types/navigation'

const coreNav: ${namespacePascal}NavigationItem[] = [
  {
    label: 'Overview',
    href: '${namespaceRoutePath}',
    icon: House,
    group: 'General',
    position: 0,
  },
  {
    label: 'Media',
    href: '${namespaceRoutePath}/media',
    icon: ImagePlay,
    group: 'General',
    position: 1,
  },
]

function comparePositions(a?: number, b?: number): number {
  if (a != null && b != null) return a - b
  if (a != null) return -1
  if (b != null) return 1
  return 0
}

const combinedNavigation = [
  ...coreNav${spreadLinesContent}
]

const dashboard = combinedNavigation.find((item) => item.href === '${namespaceRoutePath}')
const others = combinedNavigation.filter((item) => item.href !== '${namespaceRoutePath}')

others.sort((a, b) => {
  if (!a.group && b.group) return -1
  if (a.group && !b.group) return 1
  if (a.group && b.group && a.group !== b.group) {
    return comparePositions(a.groupPosition, b.groupPosition) || a.group.localeCompare(b.group)
  }
  return comparePositions(a.position, b.position) || a.label.localeCompare(b.label)
})

export const ${namespaceCamel}Navigation = [...(dashboard ? [dashboard] : []), ...others]
`
}
